import React from 'react';
import PropTypes from 'prop-types';
import OpenLinkIcon from '../../../../../icons/icon-external-link.svg';


const ModalFooter = function ModalFooter({
  title, description, ctaText, ctaLink,
}) {
  return (
    <div className="opco-nav-footer__container">
      <div className="opco-nav-footer__title">
        {title}
      </div>
      <div className="opco-nav-footer__content">
        {description}
        &nbsp;
        <a
          target="_blank"
          href={ctaLink}
          className="opco-nav-footer__content__link"
          rel="noopener noreferrer"
        >
          <span className="opco-nav-footer__content__link__text">
            {ctaText}
          </span>
          <OpenLinkIcon className="opco-nav-footer__content__link__open-link-icon" />
        </a>
      </div>
    </div>
  );
};

ModalFooter.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
  ctaLink: PropTypes.string.isRequired,
};

export default ModalFooter;
